import { render, staticRenderFns } from "./variables-dropdown.vue?vue&type=template&id=d48ddabc"
import script from "./variables-dropdown.vue?vue&type=script&lang=js"
export * from "./variables-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports